import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';
import { COMPANY } from '../constants/company';
import { LEGAL_LINKS } from '../legal/documents';

// Links to the offer, the privacy policy, the consent and the requisites, plus the operator line.
// Shown on the public pages and at the bottom of the cabinet.
const LegalFooter = ({ sx }) => (
  <Box component="footer" sx={{ textAlign: 'center', color: '#6B7280', fontSize: '0.75rem', ...sx }}>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', columnGap: 2, rowGap: 0.5, mb: 0.75 }}>
      {LEGAL_LINKS.map((l) => (
        <Link key={l.to} component={RouterLink} to={l.to} underline="hover" sx={{ color: '#6B7280', fontSize: '0.75rem' }}>
          {l.label}
        </Link>
      ))}
    </Box>
    <Typography sx={{ fontSize: '0.75rem', color: '#9CA3AF' }}>
      © {new Date().getFullYear()} {COMPANY.shortName} · ИНН {COMPANY.inn} · ОГРН {COMPANY.ogrn} · {COMPANY.email}
    </Typography>
    <Typography sx={{ fontSize: '0.75rem', color: '#9CA3AF' }}>
      Сервис не является продуктом Wildberries, Ozon или Яндекс Маркета.
    </Typography>
  </Box>
);

export default LegalFooter;
